import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid"
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react"
import dayjs from "dayjs"

interface ReactDatePickerCustomHeaderProps {
  date: Date
  decreaseMonth: () => void
  increaseMonth: () => void
  changeMonth: (month: number) => void
  changeYear: (year: number) => void
  prevMonthButtonDisabled: boolean
  nextMonthButtonDisabled: boolean
}

const months = [
  "1월",
  "2월",
  "3월",
  "4월",
  "5월",
  "6월",
  "7월",
  "8월",
  "9월",
  "10월",
  "11월",
  "12월",
]

function yearRange(start: number, end: number, step: number = -1): number[] {
  const arr = [] as number[]
  if (step > 0) {
    for (let i = end - 1; i >= start; i -= step) {
      arr.push(i)
    }
  } else {
    for (let i = start; i >= end; i += step) {
      arr.push(i)
    }
  }
  return arr
}

const years = yearRange(dayjs().year() + 1, dayjs().year() - 5)

const getYear = (date: Date) => {
  return date.getFullYear()
}

const getMonth = (date: Date) => {
  return date.getMonth()
}

export default function DatePickerHeader({
  date,
  decreaseMonth,
  increaseMonth,
  changeMonth,
  changeYear,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) {
  return (
    <div className="flex items-center justify-between px-[2px]">
      <Button
        isIconOnly
        variant="light"
        aria-label="이전 달로 이동"
        disabled={prevMonthButtonDisabled}
        onClick={decreaseMonth}
        style={{ borderRadius: "50%" }}
        className={prevMonthButtonDisabled ? "text-[#E5E7EB]" : "text-[#777E85]"}
      >
        <ChevronLeftIcon className="n-5 w-5" />
      </Button>

      <div
        className="flex text-[18px] text-[#171D23]"
        onClick={e => e.stopPropagation()}
      >
        <Dropdown onClick={e => e.stopPropagation()}>
          <DropdownTrigger>
            <div className="cursor-pointer">{getYear(date)}</div>
          </DropdownTrigger>
          <DropdownMenu
            aria-label="Year Action"
            className="max-h-[246px] overflow-auto"
            onAction={key => changeYear(Number(key))}
            onClick={e => e.stopPropagation()}
          >
            {years.map(year => (
              <DropdownItem key={year} textValue={String(year)}>
                {year}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
        .
        <Dropdown>
          <DropdownTrigger>
            <div className="cursor-pointer">{months[getMonth(date)]}</div>
          </DropdownTrigger>
          <DropdownMenu
            aria-label="Year Action"
            className="max-h-[246px] overflow-auto"
            onAction={key => changeMonth(months.indexOf(key as string))}
          >
            {months.map(month => (
              <DropdownItem key={month} textValue={String(month)}>
                {month}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>

      <Button
        isIconOnly
        variant="light"
        aria-label="다음 달로 이동"
        disabled={nextMonthButtonDisabled}
        onClick={increaseMonth}
        style={{ borderRadius: "50%" }}
        className={nextMonthButtonDisabled ? "text-[#E5E7EB]" : "text-[#777E85]"}
      >
        <ChevronRightIcon className="n-5 w-5" />
      </Button>
    </div>
  )
}
